















































































































































































































































































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  PartnerFunctionType,
  BankCustodian,
  ServicingPartner,
  FeeWaiverType,
  InstrumentList,
  InvestmentFeeScheduleSettingsFormVariant
} from "@/admin/types";
import {
  cloneDeep,
  some
} from "lodash";
import VueRouter, { Location } from "vue-router";
import { Validator } from "vee-validate";
import UsStateSelector from "@/shared/components/UsStateSelector.vue";
import Input from "@/shared/components/ui/Input.vue";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import Button from "@/shared/components/ui/Button.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import EmployerPhone from "@/employer/components/shared/EmployerPhone.vue";
import FileUpload from "vue-upload-component";
import {
  InvestmentCustodian,
  InvestmentFeeSchedule,
  AllowedInvestmentAccountTypes,
  FeeCollectionType,
  UserPermission
} from "@/shared/types";
import InvestmentFeeScheduleSettings from "@/admin/components/shared/InvestmentFeeScheduleSettings.vue";
import { custodianDisplayName } from "@/shared/custodianSettingsHelper";
import { useNotifierStore } from "@/shared/store/notifier";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useInstrumentListStore } from "@/admin/store/instrumentList";
import { usePartnerStore } from "@/admin/store/partner";
import StoreConfiguration from "@/admin/components/shared/StoreConfiguration.vue";

const fallbackAdvisoryDefaultId = 1;
const fallbackOpenBrokerageDefaultId = 2;

@Component({
  components: {
    UsStateSelector,
    Input,
    Checkbox,
    Button,
    EmployerPhone,
    ErrorSummary,
    FileUpload,
    InvestmentFeeScheduleSettings,
    StoreConfiguration
  }
})
export default class PartnerDetails extends Vue {
  $router: VueRouter;
  $validator: Validator;

  notifierStore = useNotifierStore();
  featureFlagStore = useFeatureFlagStore();
  rolePermissionsStore = useRolePermissionsStore();
  instrumentListStore = useInstrumentListStore();
  partnerStore = usePartnerStore();

  @Prop()
  partnerId?: number;

  @Prop()
  routeToPartner: (partnerId: number) => Location;

  @Prop()
  routeToPartnerList: () => Location;

  // form fields
  partnerName = "";
  partnerWebsite = "";
  externalPartnerId = "";
  ein = "";
  partnerPhone = "";
  address1 = "";
  address2 = "";
  city = "";
  state = "";
  zip = "";
  ownerFirstName = "";
  ownerLastName = "";
  ownerPhone = "";
  ownerJobTitle = "";
  ownerEmail = "";
  functionTypes: PartnerFunctionType[] = [];
  tpaId = "";
  invoicing = "";
  contractOwner = "";
  partnerDisplayName = "";
  partnerCustodian = BankCustodian.None;
  partnerCustodianLocked = false;
  isSellingPartner = false;
  selectedServicingPartners = Array<number>();
  availableServicingPartners = Array<ServicingPartner>();
  automaticallyRemoveOrphans = false;
  displayInvestmentThreshold = false;
  investmentThreshold = {
    investmentProvider: InvestmentCustodian.None,
    individual: { accountCreate: null, moneyTransfer: null },
    employer: { accountCreate: null, moneyTransfer: null }
  };
  individualMonthlyFeeAmount = "";
  individualFeeStartDate = null;
  individualEmployerId = 0;
  feeWaiverType = "";
  feeWaiverThreshold = "";
  investmentEnrollmentType: AllowedInvestmentAccountTypes;
  unsavedFeeSchedule: {
    isDirty: boolean;
    partnerId: number;
    feeSchedules: InvestmentFeeSchedule[];
  } = { partnerId: 0, feeSchedules: null, isDirty: false };
  advisoryListId = fallbackAdvisoryDefaultId;
  openBrokerageListId = fallbackOpenBrokerageDefaultId;
  ssoDisabled = false;
  investmentFeeCollectionType = FeeCollectionType.InvestmentAccount;
  ssoUserSyncStatus = false;

  // other
  isLoaded = false;
  isSubmitting = false;
  $refs: any;

  // validation
  externalPartnerIdMaxLength = 255;

  get showSsoUserSync () {
    return this.partnerCustodian === BankCustodian.HsaBank;
  }

  get isAdvisoryInstrumentListDisabled () {
    return this.investmentEnrollmentType.hasAdvisory && this.partnerCustodian === BankCustodian.HsaBank;
  }

  created (): void {
    this.onPartnerIdChanged();
    this.partnerStore.getTpaIds();
    this.instrumentListStore.loadInstrumentLists();
  }

  @Watch("partnerId")
  onPartnerIdChanged () {
    if (this.isSubmitting) {
      return;
    }

    if (this.partnerId) {
      this.partnerStore.loadInvestmentFeeSchedules(this.partnerId);
      this.instrumentListStore.loadPartnerInstrumentList(this.partnerId);
    }

    if (this.partnerStore.isInvestmentFeeSchedulesLoaded) {
      this.storeFeeSchedulesChanged(this.partnerStore.investmentFeeSchedules);
    }

    if (this.partnerId) {
      this.isLoaded = false;

      this.partnerStore.partnerLoad(this.partnerId).then(response => {
        if (response.error) {
          this.notifierStore.setDanger(response.error);
        } else {
          const p = response.partner;
          this.partnerName = p.partnerName;
          this.partnerWebsite = p.partnerWebsite;
          this.externalPartnerId = p.externalPartnerId;
          this.ein = p.partnerEin;
          this.partnerPhone = p.partnerPhone;
          this.address1 = p.partnerAddress1;
          this.address2 = p.partnerAddress2;
          this.city = p.partnerCity;
          this.state = p.partnerState;
          this.zip = p.partnerZip;
          this.ownerFirstName = p.ownerFirstName;
          this.ownerLastName = p.ownerLastName;
          this.ownerPhone = p.ownerPhone;
          this.ownerJobTitle = p.ownerJobTitle;
          this.ownerEmail = p.ownerEmail;
          this.partnerDisplayName = p.partnerDisplayName;
          this.functionTypes = p.functionTypes;
          this.tpaId = p.tpaId;
          this.invoicing = p.invoicing;
          this.contractOwner = p.contractOwner;
          this.individualMonthlyFeeAmount = p.individualMonthlyFeeAmount as any;
          this.individualFeeStartDate = p.individualFeeStartDate;
          this.feeWaiverType = p.feeWaiverType;
          this.feeWaiverThreshold = p.feeWaiverThreshold as any;
          this.partnerCustodian = p.partnerCustodian;
          this.partnerCustodianLocked = p.partnerCustodianLocked;
          this.availableServicingPartners = p.servicingPartners;
          this.selectedServicingPartners = p.servicingPartners
            .filter(p => p.isSelected).map(p => p.partnerId);
          this.setIsSellingPartner();
          this.automaticallyRemoveOrphans = p.automaticallyRemoveOrphans;
          this.investmentThreshold = p.investmentThreshold;
          this.individualEmployerId = p.individualEmployerId;
          this.investmentEnrollmentType = p.investmentEnrollmentType;
          this.setInvestmentProvider();
          this.instrumentListStore.loadCustodianDefaultInstrumentList(this.mapBankCustodianToId(p.partnerCustodian))
            .then(x => {
              if (this.isAdvisoryInstrumentListDisabled) {
                this.advisoryListId = fallbackAdvisoryDefaultId;
              }
              else if (this.instrumentListStore.partnerInstrumentList.partnerAdvisoryListId) {
                this.advisoryListId = this.instrumentListStore.partnerInstrumentList.partnerAdvisoryListId;
              } else {
                this.advisoryListId = this.instrumentListStore.advisoryCustodianDefaultInstrumentList ?
                  this.instrumentListStore.advisoryCustodianDefaultInstrumentList.listId
                  : fallbackAdvisoryDefaultId;
              }
              if (this.instrumentListStore.partnerInstrumentList.partnerOpenBrokerageListId) {
                this.openBrokerageListId = this.instrumentListStore.partnerInstrumentList.partnerOpenBrokerageListId;
              } else {
                this.openBrokerageListId = this.instrumentListStore.openBrokerageCustodianDefaultInstrumentList ?
                  this.instrumentListStore.openBrokerageCustodianDefaultInstrumentList.listId
                  : fallbackOpenBrokerageDefaultId;
              }
            });
          this.ssoDisabled = p.ssoDisabled;
          this.investmentFeeCollectionType = p.feeCollectionType;
          this.ssoUserSyncStatus = p.ssoUserSyncStatus;
        }

        this.isLoaded = true;
      }).catch(err => {
        this.notifierStore.setDanger(`Could not load partner with id: ${this.partnerId}`);
        this.isLoaded = true;
      });
    } else {
      this.isLoaded = true;
      this.partnerName = "";
      this.partnerWebsite = "";
      this.ein = "";
      this.partnerPhone = "";
      this.address1 = "";
      this.address2 = "";
      this.city = "";
      this.state = "";
      this.zip = "";
      this.ownerFirstName = "";
      this.ownerLastName = "";
      this.ownerPhone = "";
      this.ownerJobTitle = "";
      this.ownerEmail = "";
      this.functionTypes = [];
      this.tpaId = "";
      this.invoicing = "";
      this.contractOwner = "";
      this.partnerDisplayName = "";
      this.externalPartnerId = "";
      this.partnerCustodian = BankCustodian.None;
      this.partnerCustodianLocked = false;
      this.automaticallyRemoveOrphans = false;
      this.investmentThreshold = {
        investmentProvider: InvestmentCustodian.None,
        individual: { accountCreate: null, moneyTransfer: null },
        employer: { accountCreate: null, moneyTransfer: null }
      };
      this.individualMonthlyFeeAmount = null;
      this.individualFeeStartDate = null;
      this.individualEmployerId = 0;
      this.feeWaiverType = "";
      this.feeWaiverThreshold = "";
      this.ssoDisabled = false;
      this.investmentFeeCollectionType = FeeCollectionType.InvestmentAccount;
      this.ssoUserSyncStatus = false;
    }
  }

  mapBankCustodianToId (custodian: BankCustodian) {
    const custodianIdMap = {
      umb: 1,
      elements: 2,
      ucb: 3,
      avidia: 4,
      allegacy: 5,
      hsaBank: 6,
      omnibus: 7
    };

    return custodianIdMap[custodian];
  }

  onInvestmentTypeChanged (investmentEnrollmentType: AllowedInvestmentAccountTypes) {
    this.investmentEnrollmentType = investmentEnrollmentType;
  }

  @Watch("partnerStore.investmentFeeSchedules")
  storeFeeSchedulesChanged (v) {
    this.unsavedFeeSchedule = { partnerId: this.partnerId, feeSchedules: cloneDeep(v), isDirty: false };
  }

  formatDisplayName (instrument: InstrumentList) {
    return `${instrument.listName}`;
  }

  get unsavedFeeSchedulesValue () {
    return this.unsavedFeeSchedule && this.unsavedFeeSchedule.feeSchedules;
  }

  set unsavedFeeSchedulesValue (v) {
    this.unsavedFeeSchedule.feeSchedules = v;
    this.unsavedFeeSchedule.isDirty = true;
  }

  get tpaIdSelectOptions () {
    return this.partnerStore.tpaIds.map(x => {
      return {
        value: x,
        text: x
      };
    });
  }

  get custodianSelectOptions () {
    return Object.keys(BankCustodian)
      .filter(k => BankCustodian[k] !== BankCustodian.None)
      .map(k => ({ value: BankCustodian[k], text: custodianDisplayName(BankCustodian[k]) }));
  }

  get investmentCustodianSelectOptions () {
    return Object.keys(InvestmentCustodian)
      .map(k => ({ value: InvestmentCustodian[k], text: k.toUpperCase() }));
  }

  get showTpa () {
    return this.partnerCustodian === BankCustodian.Umb;
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  setIsSellingPartner () {
    this.isSellingPartner = this.functionTypes.includes(PartnerFunctionType.Sales);
  }

  get canEditExternalPartnerId () {
    return this.partnerCustodian === BankCustodian.HsaBank;
  }

  get investmentFeeScheduleSettingsFormVariant () {
    return InvestmentFeeScheduleSettingsFormVariant.partner;
  }

  submit () {
    this.$validator.validateAll()
      .then(isValid => {

        if (!this.partnerId)  {
          this.$refs.storeConfigurationRef.$validator.validateAll().then(va => {
            if (!va) {
              return;
            }
          });
        }

        if (!isValid ) {
          return;
        }

        this.isSubmitting = true;
        this.partnerStore.partnerSave({
          partnerId: this.partnerId,
          partnerName: this.partnerName,
          partnerWebsite: this.partnerWebsite,
          partnerEin: this.ein,
          partnerPhone: this.partnerPhone,
          partnerAddress1: this.address1,
          partnerAddress2: this.address2,
          partnerCity: this.city,
          partnerState: this.state,
          partnerZip: this.zip,
          ownerFirstName: this.ownerFirstName,
          ownerLastName: this.ownerLastName,
          ownerPhone: this.ownerPhone,
          ownerJobTitle: this.ownerJobTitle,
          ownerEmail: this.ownerEmail,
          functionTypes: this.functionTypes,
          tpaId: this.tpaId,
          invoicing: this.invoicing,
          contractOwner: this.contractOwner,
          individualMonthlyFeeAmount: this.individualMonthlyFeeAmount,
          individualFeeStartDate: this.individualFeeStartDate,
          feeWaiverType: this.feeWaiverType,
          feeWaiverThreshold: this.feeWaiverThreshold,
          partnerCustodian: this.partnerCustodian,
          partnerDisplayName: this.partnerDisplayName,
          externalPartnerId: this.externalPartnerId,
          servicingPartners: this.getSelectedPartners(),
          automaticallyRemoveOrphans: this.automaticallyRemoveOrphans,
          investmentThreshold: this.investmentThreshold,
          individualEmployerId: this.individualEmployerId,
          investmentEnrollmentType: this.investmentEnrollmentType,
          feeCollectionType: this.investmentFeeCollectionType,
          ssoUserSyncStatus: this.ssoUserSyncStatus,
          storeConfiguration: !this.partnerId
            ? this.$refs.storeConfigurationRef.storeInfo
            : null
        } as any)
          .then(() => {
            if (this.displayInvestmentFeeSchedule) {
              return this.instrumentListStore.setPartnerInstrumentList({
                partnerId: this.partnerId,
                advisoryListId: this.advisoryListId,
                openBrokerageListId: this.openBrokerageListId
              } as any);
            }
          })
          .then(() => {
            if (this.savePartnerData) {
              return this.partnerStore.saveInvestmentFeeSchedules(
                { partnerId: this.partnerId, feeSchedules: this.unsavedFeeSchedulesValue });
            }
          })
          .then(result => {
            this.$router.push(this.routeToPartnerList());
            this.isSubmitting = false;
          })
          .catch(_ => {
            this.isSubmitting = false;
          });
      });
  }

  get savePartnerData () {
    return this.displayInvestmentFeeSchedule === true
      && this.unsavedFeeSchedule.feeSchedules
      && this.unsavedFeeSchedule.partnerId === this.partnerId
      && this.unsavedFeeSchedule.isDirty;
  }

  get functionTypeOptions () {
    return Object.keys(PartnerFunctionType)
      .filter(k => PartnerFunctionType[k] !== PartnerFunctionType.None)
      .map(k => ({ value: PartnerFunctionType[k], text: k }));
  }

  get disableTpaSelection () {
    return this.partnerId && this.tpaId !== null && this.tpaId !== "";
  }

  get disableCustodianSelection () {
    return this.partnerCustodianLocked;
  }

  get displayInvestmentFeeSchedule () {
    return this.partnerId && (this.investmentThreshold.investmentProvider === InvestmentCustodian.Drivewealth
      || this.isElements);
  }

  get isElements () {
    return this.partnerId === 4;
  }

  setInvestmentProvider () {
    this.displayInvestmentThreshold =
      this.investmentThreshold.investmentProvider === InvestmentCustodian.Tda ||
      this.investmentThreshold.investmentProvider === InvestmentCustodian.Drivewealth;

    if (!this.displayInvestmentThreshold) {
      // reset threshold values
      this.investmentThreshold.individual.accountCreate = null;
      this.investmentThreshold.individual.moneyTransfer = null;
      this.investmentThreshold.employer.accountCreate = null;
      this.investmentThreshold.employer.moneyTransfer = null;
    }
  }

  get contractOwnerOptions () {
    return [
      { value: "bend", text: "Bend" },
      { value: "partner", text: "Partner" },
    ];
  }

  get invoicingOptions () {
    return [
      { value: "bend", text: "Bend Sends" },
      { value: "partner", text: "Partner Sends" },
    ];
  }

  get feeCollectionOptions () {
    let options = [
      { value: FeeCollectionType.InvestmentAccount, text: "Participant Account" },
      { value: FeeCollectionType.Partner, text: "Partner" },
      { value: FeeCollectionType.Employer, text: "Employer" },
      { value: FeeCollectionType.HsaBank, text: "HSA Bank" }
    ];

    // HSA Bank cannot collect investment fees from HSA account
    if (this.partnerCustodian !== BankCustodian.HsaBank) {
      options = [{ value: FeeCollectionType.HsaAccount, text: "Participant HSA Account" }, ...options];
    }

    return options;
  }

  get isContractOwnerValid () {
    return !this.errors.has("contract owner");
  }

  get servicingPartners () {
    if (!this.isLoaded) return [];
    return this.availableServicingPartners
      .map(sp => ({ value: sp.partnerId, text: sp.partnerName }));
  }

  getSelectedPartners () {
    return this.availableServicingPartners.filter(servicingPartner =>
      some(this.selectedServicingPartners, partnerId => partnerId === servicingPartner.partnerId))
      .map(v => ({ ...v, isSelected: true }));
  }

  get fullyLoaded () {
    return this.isLoaded && (!this.displayInvestmentFeeSchedule || this.partnerStore.isInvestmentFeeSchedulesLoaded);
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerEdit);
  }

  get hasViewPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerEdit) ||
      this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerView);
  }

  onfeeWaiverTypeChange (value) {
    if (value === FeeWaiverType.None) {
      this.feeWaiverThreshold = "";
    }
  }

  get feeCollectionAccountDescription () {
    const isDrivewealth = this.investmentThreshold.investmentProvider === InvestmentCustodian.Drivewealth;
    const isFeeCollectionThroughInvestmentAccount =
      this.investmentFeeCollectionType === FeeCollectionType.InvestmentAccount;

    if (!isDrivewealth && isFeeCollectionThroughInvestmentAccount) {
      return "Only Drivewealth accounts can be billed from investments";
    }

    return "";
  }
}
